import React from 'react';
import Table from '../../common/TablePerformance';
import { connect } from 'react-redux';
import { changeSortState, REDUCER_NAME } from '../reducer';
import Const from './Const';

const getDataFromRedux = state =>
  state[REDUCER_NAME].listObjectDataTopGainersByTicker;

function TablePerformanceTopGainer(props) {
  const { listId, isLoading, sortState, changeSortState } = props;

  return (
    <Table
      sortState={sortState}
      onSort={changeSortState}
      listId={listId}
      isLoading={isLoading}
      getDataFromRedux={getDataFromRedux}
      listColumns={Const.listColumn}
      resizable={true}
      columnDraggable={false}
      rowDraggable={false}
      i18nTitleKey="topVolume.performance.listTitleTable"
    />
  );
}

const mapStateToProps = state => {
  return {
    listId: state[REDUCER_NAME].listDataTopGainersTicker,
    isLoading: state[REDUCER_NAME].isLoading,
    sortState: state[REDUCER_NAME].sortState,
  };
};

const mapDispatchToProps = {
  changeSortState,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TablePerformanceTopGainer);
